var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTop1Leaderboard = function SvgIconTop1Leaderboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__a)",
    d: "M19.264 19.813V8.9l.704.543h-3.296V8.133H20.8v11.68h-1.536Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__b)",
    d: "M5.108 13.807s.56-1.332-.404-2.716C3.74 9.71 2.29 9.474 2.29 9.474s-.615 1.574.326 2.922c.94 1.348 2.493 1.411 2.493 1.411Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__c)",
    d: "M7.693 13.956s1.464-.52 1.962-2.088c.499-1.566-.557-2.886-.557-2.886s-1.313.654-1.825 2.262c-.512 1.607.42 2.712.42 2.712Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__d)",
    d: "M8.318 15.677c-.297 1.66.77 2.635.77 2.635s1.385-.709 1.675-2.326c.288-1.618-.93-2.789-.93-2.789s-1.217.819-1.515 2.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__e)",
    d: "M12.018 15.965s-1.134.931-1.274 2.61c-.14 1.683 1.014 2.552 1.014 2.552s1.31-.834 1.447-2.473c.136-1.637-1.187-2.69-1.187-2.69Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__f)",
    d: "M15.255 23.74s1.016-1.178.675-2.786c-.342-1.608-1.912-2.233-1.912-2.233s-.818 1.218-.469 2.868c.351 1.648 1.706 2.15 1.706 2.15Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__g)",
    d: "M6.224 10.342s1.206-.797 1.17-2.482C7.36 6.174 6.285 5.174 6.285 5.174s-1.384.968-1.35 2.612c.034 1.643 1.289 2.556 1.289 2.556Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__h)",
    d: "M6.008 17.168s.141-1.438-1.187-2.475c-1.33-1.037-2.784-.835-2.784-.835s-.124 1.686 1.172 2.697c1.296 1.012 2.799.613 2.799.613Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__i)",
    d: "M8.03 20.325s-.183-1.434-1.708-2.15c-1.528-.715-2.9-.195-2.9-.195s.254 1.672 1.741 2.37c1.489.696 2.866-.025 2.866-.025Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__j)",
    d: "M10.464 22.73s-.605-1.313-2.276-1.532c-1.674-.22-2.823.691-2.823.691s.748 1.517 2.377 1.732c1.629.213 2.722-.892 2.722-.892Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__k)",
    d: "M11.511 23.714c-1.686-.018-2.72 1.024-2.72 1.024s.923 1.416 2.566 1.434c1.645.018 2.598-1.21 2.598-1.21s-.758-1.23-2.444-1.248Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__l)",
    d: "m6.64 11.24-.79-.156c-.015.086-1.561 8.667 10.828 14.583l.346-.725C5.228 19.308 6.576 11.566 6.64 11.24Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__m)",
    d: "M35.828 13.832s-.56-1.333.404-2.715c.964-1.384 2.414-1.619 2.414-1.619s.615 1.573-.326 2.921c-.938 1.35-2.492 1.413-2.492 1.413Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__n)",
    d: "M33.243 13.976s-1.463-.522-1.963-2.088c-.498-1.567.557-2.886.557-2.886s1.313.654 1.827 2.261c.511 1.609-.42 2.713-.42 2.713Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__o)",
    d: "M32.618 15.704c.297 1.661-.77 2.636-.77 2.636s-1.385-.709-1.676-2.326c-.287-1.618.931-2.79.931-2.79s1.217.82 1.515 2.48Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__p)",
    d: "M28.918 15.98s1.134.93 1.274 2.613c.14 1.681-1.015 2.55-1.015 2.55s-1.31-.835-1.446-2.473c-.136-1.639 1.187-2.69 1.187-2.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__q)",
    d: "M25.679 23.763s-1.015-1.177-.674-2.785c.342-1.609 1.913-2.234 1.913-2.234s.817 1.218.468 2.869c-.35 1.65-1.707 2.15-1.707 2.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__r)",
    d: "M34.71 10.366s-1.204-.797-1.169-2.482c.035-1.685 1.11-2.686 1.11-2.686s1.385.967 1.35 2.612c-.034 1.642-1.291 2.556-1.291 2.556Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__s)",
    d: "M34.928 17.192s-.141-1.438 1.186-2.475c1.331-1.037 2.785-.835 2.785-.835s.125 1.686-1.172 2.697c-1.297 1.012-2.799.613-2.799.613Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__t)",
    d: "M32.907 20.342s.18-1.434 1.708-2.152c1.527-.715 2.899-.194 2.899-.194s-.254 1.673-1.742 2.37c-1.488.696-2.865-.024-2.865-.024Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__u)",
    d: "M30.47 22.747s.607-1.313 2.279-1.533c1.674-.22 2.822.691 2.822.691s-.748 1.516-2.377 1.73c-1.63.216-2.724-.888-2.724-.888Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__v)",
    d: "M29.424 23.74c1.686-.018 2.72 1.023 2.72 1.023s-.921 1.415-2.566 1.436c-1.643.016-2.596-1.211-2.596-1.211s.756-1.23 2.442-1.249Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top1-leaderboard_svg__w)",
    d: "m34.294 11.263.792-.156c.016.086 1.561 8.668-10.829 14.583l-.345-.725c11.794-5.633 10.446-13.377 10.382-13.702Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__a",
    x1: 16.568,
    x2: 24.127,
    y1: 7.423,
    y2: 8.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__b",
    x1: 2.223,
    x2: 5.122,
    y1: 10.738,
    y2: 10.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__c",
    x1: 6.872,
    x2: 10.148,
    y1: 10.704,
    y2: 10.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__d",
    x1: 8.031,
    x2: 11.069,
    y1: 14.883,
    y2: 14.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__e",
    x1: 10.517,
    x2: 13.412,
    y1: 17.614,
    y2: 17.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__f",
    x1: 13.381,
    x2: 16.023,
    y1: 20.201,
    y2: 19.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__g",
    x1: 4.799,
    x2: 7.538,
    y1: 6.834,
    y2: 6.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__h",
    x1: 2.41,
    x2: 5.843,
    y1: 14.829,
    y2: 14.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__i",
    x1: 3.937,
    x2: 7.856,
    y1: 18.727,
    y2: 19.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__j",
    x1: 5.847,
    x2: 10.129,
    y1: 22.213,
    y2: 23.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__k",
    x1: 9.231,
    x2: 13.519,
    y1: 24.832,
    y2: 26.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__l",
    x1: 6.889,
    x2: 15.311,
    y1: 15.087,
    y2: 14.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__m",
    x1: 36.513,
    x2: 39.132,
    y1: 10.173,
    y2: 11.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__n",
    x1: 31.559,
    x2: 34.444,
    y1: 10.053,
    y2: 11.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__o",
    x1: 30.595,
    x2: 33.316,
    y1: 14.292,
    y2: 15.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__p",
    x1: 28.222,
    x2: 30.84,
    y1: 17.041,
    y2: 18.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__q",
    x1: 25.554,
    x2: 27.975,
    y1: 19.689,
    y2: 20.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__r",
    x1: 34.062,
    x2: 36.554,
    y1: 6.301,
    y2: 7.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__s",
    x1: 35.886,
    x2: 38.868,
    y1: 14.146,
    y2: 15.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__t",
    x1: 33.873,
    x2: 37.077,
    y1: 17.905,
    y2: 20.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__u",
    x1: 31.278,
    x2: 34.411,
    y1: 21.208,
    y2: 24.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__v",
    x1: 27.718,
    x2: 30.74,
    y1: 23.789,
    y2: 27.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top1-leaderboard_svg__w",
    x1: 27.672,
    x2: 35.406,
    y1: 13.402,
    y2: 16.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#EDC358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#C69029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6D19"
  })))));
};
export default SvgIconTop1Leaderboard;